// extracted by mini-css-extract-plugin
module.exports = {"poolDetailPage":"ResourcepoolDetail_poolDetailPage__wqvPI","nav":"ResourcepoolDetail_nav__1ls1J","icon":"ResourcepoolDetail_icon__23B7t"};